import axios from '../axiosFlotex'

const resource = 'new_customer_wizard'
export default {
  get(token) {
    return axios.get(`${resource}/${token}`).then((result) => {
      // console.log(result.data)
      // if(typeof result.data.contractRepresentatives === 'undefined'){
      // if (result.data?.contractRepresentatives == undefined) {
      //   result.data.contractRepresentatives = []
      // }
      return result.data
    })
  },

  step(token, step) {
    // console.log(['axios step', token, step])
    let data = {
      token,
      currentStep: step
    }

    // Testy ustawień grup serializacji
    // data.emailCardPin = 'step'+step+'@test.pl'
    // data.customerNote = 'notatka step '+step+' a powinna być tylko po zatwierdzeniu kroku 6!'

    return axios
      .post(`${resource}/${token}/change-step`, data)
      .then((result) => {
        // console.log(result.data)
        // console.log(['axios step', token, step])
        return result.data
      })
  },

  nextStep(blank) {
    let token = blank.token && blank.token
    let step = blank.currentStep
    // console.log(['axios nextStep', token, step])

    if (typeof token == 'undefined' || typeof step == 'undefined') {
      return Promise.reject('Insufficient data to make api call')
    }

    let data = JSON.parse(JSON.stringify(blank))
    // console.log(data)

    // Testy ustawień grup serializacji
    // blank.emailCardPin = 'sub_step'+blank.currentStep+'@test.pl'
    // blank.customerNote = 'submit: notatka step '+blank.currentStep+' a powinna być tylko po zatwierdzeniu kroku 6!'
    // blank.court = null
    return axios
      .post(`${resource}/${token}/step${step}`, data)
      .then((result) => {
        // console.log(result.data)
        // console.log(['axios step', token, step])
        return result.data
      })
  },

  survey(blank) {
    let token = blank.token && blank.token

    if (typeof token == 'undefined') {
      return Promise.reject('Insufficient data to make api call')
    }

    return axios.post(`${resource}/${token}/survey`, blank).then((result) => {
      // console.log(result.data)
      // console.log(['axios step', token, step])
      return result.data
    })
  },

  // acceptPromoShellFerrariRules(blank) {
  //   let token = blank.token && blank.token

  //   if (typeof token == 'undefined') {
  //     return Promise.reject('Insufficient data to make api call')
  //   }

  //   return axios
  //     .post(`${resource}/${token}/accept_shell_ferrari_rules`)
  //     .then((result) => {
  //       console.log(result.data)
  //       return result.data
  //     })
  // },

  uploadAttachment(token, formFile, onUploadProgress) {
    // console.log(['uploadAttachment', token, formFile])
    // let url = `${resource}/${token}/uploadAttachment`
    let url = `${resource}/${token}/attachment`
    return axios
      .post(url, formFile, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        ...(typeof onUploadProgress == 'function'
          ? { onUploadProgress: onUploadProgress }
          : {})
      })
      .then((result) => {
        // console.log(['uploadAttachment', result.data])
        return result.data
      })
  },

  deleteAttachment(token, fileId) {
    // console.log(['uploadAttachment', token, formFile])
    // let url = `${resource}/${token}/uploadAttachment`
    let url = `${resource}/${token}/attachment/${fileId}`
    return axios.delete(url).then((result) => {
      // console.log(['deleteAttachment', result.data])
      return result.data
    })
  }
}
